import stateManager from '../../../../modules/user/stateManager';
import { NCD_POLICY_NOTIFICATION_ACTION } from './constants';

export const shouldShowNcdCancellationPolicyNotification = async () => {
  const hasAcceptedNcdPolicy = await stateManager.getActionValue(NCD_POLICY_NOTIFICATION_ACTION);
  return !hasAcceptedNcdPolicy;
};

export const createNcdCancellationPolicyNotification = (providerId: number) => ({
  creation_time: new Date(),
  persistent: true,
  providerId,
  type: 'ncd_cancellation_policy',
  uuid: 'ncd-cancellation-policy-notification',
});
